import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  FormControlLabel,
  Switch,
} from "@mui/material";
import StateSelect from "./StateSelect";

export default function CreateOrganizationDialog({
  open,
  onClose,
  formData,
  onFormDataChange,
  onCreate,
  creating,
}) {
  // Format EIN as XX-XXXXXXX
  const formatEIN = (value) => {
    if (!value) return '';
    // Remove all non-digit characters
    const einDigits = value.replace(/\D/g, '');
    
    // Limit to 9 digits maximum
    const limitedEIN = einDigits.slice(0, 9);
    
    // Format based on length
    if (limitedEIN.length === 0) return '';
    if (limitedEIN.length <= 2) return limitedEIN;
    // Format as XX-XXXXXXX for 9 digits
    return `${limitedEIN.slice(0, 2)}-${limitedEIN.slice(2, 9)}`;
  };

  // Get formatted display value for EIN field
  const getFormattedEIN = (value) => {
    if (!value) return '';
    return formatEIN(value);
  };

  // Handle EIN input change - store digits only, display formatted
  const handleEINChange = (value) => {
    // Extract digits only and limit to 9 digits
    const digitsOnly = value.replace(/\D/g, '').slice(0, 9);
    onFormDataChange({ ...formData, organization_ein: digitsOnly });
  };

  const handleClose = () => {
    onFormDataChange({
      organization_name: "",
      formation_state: "",
      organization_ein: "",
      is_active: true,
    });
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      maxWidth="sm" 
      fullWidth
    >
      <DialogTitle>Create Organization</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Grid container spacing={1.5}>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Organization Name (organization_name)"
              value={formData.organization_name || ""}
              onChange={(e) => onFormDataChange({ ...formData, organization_name: e.target.value })}
              margin="dense"
              size="small"
              required
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <StateSelect
              label="Formation State (formation_state)"
              value={formData.formation_state || ""}
              onChange={(e) => onFormDataChange({ ...formData, formation_state: e.target.value })}
              size="small"
              margin="dense"
              required
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <TextField
              fullWidth
              required
              label="EIN (organization_ein)"
              value={getFormattedEIN(formData.organization_ein)}
              onChange={(e) => handleEINChange(e.target.value)}
              margin="dense"
              size="small"
              placeholder="12-3456789"
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.is_active !== false}
                  onChange={(e) => onFormDataChange({ ...formData, is_active: e.target.checked })}
                />
              }
              label="Active (is_active)"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={creating}>Cancel</Button>
        <Button 
          onClick={onCreate} 
          variant="contained"
          disabled={
            !formData.organization_name?.trim() ||
            !formData.formation_state?.trim() ||
            !formData.organization_ein ||
            formData.organization_ein.replace(/\D/g, "").length !== 9 ||
            creating
          }
        >
          {creating ? "Creating..." : "Create Organization"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
